import Constant from '@/common/constant/Constant';
import { Tooltip } from '@material-ui/core';

export default function CollapseChatBox(props) {
    const {
        setIsShowChatBox,
        chatbotSettings,
        isNewUnReadMessage,
        POPUlAR_MOBILE_DEVICE_WIDTH,
        isIframeChatBot,
        deviceWidth
    } = props;
    
    const onClickOpenChatbot = () => {
        window.parent.postMessage(Constant.CHATBOT_ACTION.OPEN_CHATBOT, '*');
        setIsShowChatBox(true);
    };

    return (
        <div
            className={`collapse-chatbox ${isNewUnReadMessage ? 'random-color-chatbox' : ''}`}
            onClick={() => onClickOpenChatbot()}
        >
            <div className="chat-logo-hide">
                <img
                    src={
                        chatbotSettings?.headerIcon &&
                        chatbotSettings?.headerIcon !== Constant.SETTING_CHAT_BOT.LOGO_ICON_DEFAULT
                            ? chatbotSettings?.headerIcon
                            : Constant.SETTING_CHAT_BOT.LOGO_ICON_WHITE
                    }
                    alt="Logo"
                />
            </div>

            <div className="chat-title" onClick={() => onClickOpenChatbot()}>
                {' '}
                {isIframeChatBot && Number(deviceWidth) < Number(POPUlAR_MOBILE_DEVICE_WIDTH) ? (
                    <span>{chatbotSettings?.chatbotTextInHeader}</span>
                ) : Number(window.innerWidth) > Number(POPUlAR_MOBILE_DEVICE_WIDTH) ||
                  Number(window.outerWidth) > Number(POPUlAR_MOBILE_DEVICE_WIDTH) ? (
                    <Tooltip
                        title={chatbotSettings?.chatbotTextInHeader}
                        placement="top"
                        disableTouchListener={true}
                    >
                        <span>{chatbotSettings?.chatbotTextInHeader}</span>
                    </Tooltip>
                ) : (
                    <span>{chatbotSettings?.chatbotTextInHeader}</span>
                )}
            </div>
        </div>
    );
}
